// Конфигурация форсунок

export const NOZZLE_CONFIG = {
    /** Лимит инстансов после батча всех строк (стены + дно). Обрезка — пропорционально по side. */
    MAX_INSTANCES: 200,

    // Модель
    MODEL_PATH: '/models/nozzles/nozzle.glb',
    BASE_SCALE: [0.075, 0.075, 0.075],

    // Общие параметры позиционирования
    POSITIONING: {
        BASE_DEPTH: 1.5,
        BASE_WIDTH: 4,
        BASE_LENGTH: 4,

        // Коэффициенты масштабирования модели
        MIN_SCALE_FACTOR: 0.3,
        // Базовое смещение стеновой форсунки в сторону стены.
        BASE_WALL_OFFSET: 0.013,
        // Максимальная компенсация смещения при уменьшении модели
        // (чтобы форсунка немного выдвигалась в чашу и была видна).
        MAX_WALL_OFFSET_COMPENSATION: 0.03,
        // Минимальный итоговый отступ от стены, чтобы не вылетать слишком сильно.
        MIN_EFFECTIVE_WALL_OFFSET: 0.004,

        // Смещение донных форсунок вниз по Y (в мировых единицах сцены)
        // Увеличивайте по модулю (например, -0.02 -> -0.025), если нужно опустить ниже.
        BOTTOM_Y_OFFSET: -0.015,
    }
};
